import MainPageLayout, {type MainPageLayoutProps} from 'layouts/MainPageLayout';
import FileGrid, {type FileGridProps} from './FileGrid';

export type FileGridPageLayoutProps = FileGridProps & Omit<MainPageLayoutProps, 'children'>;

const FileGridPageLayout = ({ files, title }: FileGridPageLayoutProps): JSX.Element => {
  return (
    <MainPageLayout title={title}>
      <FileGrid files={files} />
    </MainPageLayout>
  );
};

export default FileGridPageLayout;